<template>
	<div class="footer">
		<div class="my-footer">
			<div v-if="showTop" class="footer-top">
				<div class="top-item">
					<img src="@/assets/footer/yellow-icon1.png" alt="" class="yellow-icon">
					<div class="item-right">
						<p>无需下载</p>
						<p>一键秒玩3A大作</p>
					</div>
				</div>
				<div class="top-item">
					<img src="@/assets/footer/yellow-icon2.png" alt="" class="yellow-icon">
					<div class="item-right">
						<p>低配无忧</p>
						<p>无须高配机器就能畅玩</p>
					</div>
				</div>
				<div class="top-item">
					<img src="@/assets/footer/yellow-icon3.png" alt="" class="yellow-icon">
					<div class="item-right">
						<p>多端同步</p>
						<p>多平台手机电脑均可游玩</p>
					</div>
				</div>
				<div class="top-item">
					<img src="@/assets/footer/yellow-icon4.png" alt="" class="yellow-icon">
					<div class="item-right">
						<p>海量游戏</p>
						<p>最新最快、每周上新</p>
					</div>
				</div>
			</div>
			<div v-if="showTop" class="footer-content">
				
				<div v-if="showTop" class="cont-left">
					<!-- <img src="@/assets/footer/logo.png" alt="" class="cont-left-logo"> -->
					<img src="@/assets/footer/slogan.png" alt="" class="cont-left-slogan">
				</div>
				<div v-else class="cont-left">
					<img class="logo_channel" src="../assets/download/logo_1.png">
				</div>
				<div class="cont-center">
					<div class="center-group" style="margin-right: 150px;">
						<strong>关于我们</strong>
						<p class="link" @click='jumpPath(6)'>公司介绍</p>
						<!-- <p class="link" @click='jumpPath(3)'>应用下载</p> -->
						<!-- <p class="link">游戏资讯</p> -->
					</div>
					<div v-if="showTop" class="center-group">
						<strong>联系我们</strong>
						<p>	
							<img src="@/assets/footer/qq-icon.png" alt="">
							3478489544
						</p>
						<p>
							<img src="@/assets/footer/phone-icon.png" alt="">
							0755-26417914
						</p>
						<p>
							<img src="@/assets/footer/email-icon.png" alt="">
							3478489544@qq.com
						</p>
					</div>
				</div>
				<div v-if="showTop" class="cont-right">
					<div class="right-top">
						<!-- <p class="right-top-name">粉丝交流群</p>
						<div class="fuli">
							<img src="@/assets/footer/liwu.png" alt="">
							进群领福利
						</div> -->
					</div>
					<div class="right-code-group">
						<!-- <img src="@/assets/common/wx-code.png" class="code-item" style="margin-right:40px"> -->
						<!-- <img src="@/assets/common/qq-code.png" class="code-item" style="margin-right:40px"> -->
						<!-- <img src="@/assets/common/company_code.png" class="code-item"> -->
					</div>
				</div>
			</div>
		</div>
		<div v-if="link_list.length > 0" class="link_wrap">
			<div class="title">友情链接:</div>
			<div v-for="(item, index) in link_list" :key="index"
				class="link_item" @click.stop="handle_link(item)">{{item.name}}</div>
		</div>
		<div class="footer-bottom">
			<p v-if="copyright">{{copyright}}</p>
			<p class="footer-txt name_text">应用名称：胖哒云游  | 应用版本：1.1.1 | 开发者：厦门同力合创网络科技有限公司深圳分公司</p>
			<p class="footer-txt to_text"><span @click.stop="jumpPath(1)">隐私政策</span> | <span @click.stop="jumpPath(2)">申请权限</span> | 更新时间：2023.08.01</p>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default{
		name:'toubu',
		props: {
			show: {
				type: Boolean,
				default: true
			},
			showTop: {
				type: Boolean,
				default: true
			},
			copyright: {
				type: String,
				default: ''
			},
		},
		data(){
			return {
				link_list: [],
			}
		},
		created () {
			this.get_link_list()
		},
		methods:{
			// 获取友情链接配置文件
			get_link_list () {
				const url = 'https://dl.cloudpc.cn/PC/json/friendly_link.json'
				axios.get(url).then(res=>{
					if (res) {
						console.warn(res)
						this.link_list = res
					}
				})
			},
			// 点击友情链接
			handle_link (item) {
				window.open(item.url)
			},
			jumpPath(activeIndex){
				let that=this
				console.warn(activeIndex)
				switch(activeIndex){
					case 3:
						that.$router.push('/Download.html');
						that.$bus.$emit('setActiveIndex',3);
						break;
					case 6:
						that.$router.push('/aboutUs.html');
						that.$bus.$emit('setActiveIndex',6);
						break;
					case 1:
						location.href = 'https://h5.tlhcxm.top/agreement/index.html#/pangdayinsixieyi'
						break
					case 2:
						location.href = 'https://h5.tlhcxm.top/agreement/index.html#/pangdayinsixieyi'
						break
				}
			},
			jumpPathBeian(){
				location.href = 'https://beian.miit.gov.cn/';
			}
		},
	}
</script>

<style lang="less" scoped>
	.footer{
		background-color: #000;
		position: relative;
		z-index: 1;
	}
	.my-footer{
		max-width: 1200px;
		min-width: 1000px;
		margin: 0 auto;
		height: auto;
		.footer-top{
			display: flex;
			height: 114px;
			border-bottom:1px solid #282828;
			align-items: center;
			.top-item{
				width: 25%;
				display: flex;
				align-items: center;
				border-left: 1px solid #282828;
				justify-content: center;
				height: 50px;
				.yellow-icon{
					width: 50px;
				}
				.item-right{
					margin-left: 20px;
					p:nth-child(1){
						color:#D7D7D7;
						font-weight: bold;
					}
					p:nth-child(2){
						color:#858585;
						font-size: 12px;
						margin-top: 10px;
					}
				}
			}
			.top-item:nth-last-child(1){
				border-right: 1px solid #282828;
			}
		}
		.footer-content{
			display: flex;
			justify-content: space-between;
			padding:60px 0;
			.cont-left{
				display: flex;
				flex-direction: column;
				align-items: center;
				.logo_channel {
					width: 170px;
					height: auto;
				}
				.cont-left-logo{
					width: 177px;
					height: 41px;
				}
				.cont-left-slogan{
					width: 150px;
					height: 34px;
					margin-top: 22px;
				}
			}
			.cont-center{
				display: flex;
				.center-group{
					strong{
						color:#D7D7D7;
						font-weight: bold;
						margin-bottom: 26px;
						display: block;
					}
					p{
						color:#848484;
						display: flex;
						align-items: center;
						line-height: 24px;
						margin-top: 16px;
						img{
							width: 24px;
							height: 24px;
							margin-right:10px ;
						}
					}
					.link{
						cursor: pointer;
					}
					.link:hover{
						text-decoration: underline;
					}
				}
			}
			.cont-right{
				.right-top{
					display: flex;
					align-items: center;
					.right-top-name{
						color:#D7D7D7;
						line-height: 21px;
						font-weight: bold;
						margin-right: 16px;
					}
					.fuli{
						font-size: 12px;
						color: #FFFFFF;
						line-height: 16px;
						padding:5px 12px;
						background: linear-gradient(262deg, #FC9F79 0%, #E97B1F 100%, #E97A1E 100%);
						border-radius: 13px;
						display: flex;
						align-items: center;
						img{
							width: 16px;
							height: 16px;
							margin-right: 6px;
						}
					}
				}
				.right-code-group{
					margin-top: 26px;
					display: flex;
					.code-item{
						width: 100px;
						height: 100px;
					}
				}
			}
		}  
	}
	.link_wrap {
		display: flex;
		align-items: center;
		height: 80px;
		font-size: 12px;
		width: 1200px;
		margin: 0 auto;
		box-sizing: border-box;
		border-top: 1px solid #232323;
		border-bottom: 1px solid #232323;
		.title {
			color: #7A7A7A;
		}
		.link_item {
			color: #B1B1B1;
			margin-left: 20px;
			cursor: pointer;
		}
	}
	.footer-bottom{
		background-color: #0D0D0D;
		color:#7A7A7A;
		font-size: 12px;
		padding: 26px 0;
		p{
			max-width: 1200px;
			margin: 0 auto;
			text-align: center;
			// padding:26px 0;
			span {
				cursor: pointer;
			}
		}
	}
</style>
